import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import Constants from "../../Action/Constants";

class TaskCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(): void {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_SUCCESS
    });

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    });

    this.props.dispatch({
      type: Constants.GLOBAL_UNFINISHED_TASKS_COUNT,
    });
  }

}

export { TaskCreate };
